import {useEffect,} from 'react';

import {useSubscriptions} from '../hooks/useSubscriptions.ts';
import {Subscription} from '../types';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";

export const SubscriptionsAutocomplete = (props: FieldProps & TextInputProps) => {

    const {
        items: records,
        loading,
        fetchRecords
    } = useSubscriptions();


    useEffect(() => {
        fetchRecords();
    }, []);


    return (

        <FormikGenericCombobox
            records={(records as Subscription[]) || []}
            valueFieldName={'id'}
            renderOption={(record: Subscription) => `${record.id}`}
            getSelectedOption={(record: Subscription) => `${record.id}`}
            isLoading={loading}
            {...props}
        />

    );
};